import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { PriceCalculatorContainerComponent } from './components/price-calculator-container/price-calculator-container.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [PriceCalculatorContainerComponent],
  imports: [CommonModule, FormsModule, FomanticUIModule],
  exports: [PriceCalculatorContainerComponent],
})
export class PriceCalculatorModule {}
